import React from "react";
import { motion } from "framer-motion";
import { fadeInUp, textVariants, hoverScale } from './framerAnimations';

const BusinessCard = ({ title, backgroundColor, image, index = 0 }) => {
  // Stagger delay for cards
  const cardDelay = index * 0.2;

  return (
    <motion.div
      className="rounded-3 p-3 h-100 position-relative d-flex flex-column justify-content-between"
      style={{ background: backgroundColor, minHeight: "300px" }}
      variants={fadeInUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      whileHover="hover"
      hoverVariants={hoverScale}
      transition={{
        duration: 0.8,
        ease: "easeOut",
        delay: cardDelay
      }}
    >
      <motion.h5 
        className="fw-medium text-dark text-center mb-3"
        variants={textVariants}
        initial={{ scale: 0, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        transition={{
          duration: 0.5,
          ease: "easeOut",
          delay: cardDelay + 0.3 // Popup effect after card appears
        }}
      >
        {title}
      </motion.h5>
      <motion.img
        src={image}
        alt={title}
        className="img-fluid position-absolute bottom-0 end-0"
        style={{ maxWidth: "100%", maxHeight: "60%", borderRadius: "20px" }}
        variants={textVariants}
        initial={{ y: 50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{
          duration: 0.6,
          ease: "easeOut",
          delay: cardDelay + 0.5 // Image appears last
        }}
      />
    </motion.div>
  );
};

export default BusinessCard;